import MarketplaceModule from './components/Marketplace/Marketplace';
import marketplaceEpics from './store/marketplace.epics';
import marketplaceReducer from './store/marketplace.reducer';

export { marketplaceEpics, marketplaceReducer };

export default MarketplaceModule;
